import { type ForwardedRef, forwardRef, useState } from 'react';
import { IMaskMixin } from 'react-imask';

import Input, { type TInputProps } from '../input';

export interface IMaskedInputInterface extends Omit<TInputProps, 'value'> {
  mask?: string;
  replacement?: { [key: string]: RegExp };
  value?: string;
  inputRef?: ForwardedRef<HTMLInputElement>;
  definitions?: { [key: string]: RegExp };
  overwrite?: boolean;
  unmask?: boolean;
  lazy?: boolean;
  onAccept?: (value: string) => void;
}

// Создаём компонент с маской через IMaskMixin
const MaskedInputComponent = IMaskMixin<
  HTMLInputElement,
  IMaskedInputInterface
>(({ inputRef, ...props }) => {
  return <Input ref={inputRef} {...props} />;
});

// Оборачиваем в forwardRef для поддержки forwardedRef
const MaskedInput = forwardRef<HTMLInputElement, IMaskedInputInterface>(
  ({ mask = '', replacement, value, onChange, ...props }, forwardedRef) => {
    const [showMask, setShowMask] = useState(() => false);

    return (
      <MaskedInputComponent
        inputRef={forwardedRef}
        mask={mask}
        definitions={replacement || { _: /\d/ }}
        overwrite={true}
        unmask={false}
        lazy={!showMask}
        value={value as string}
        onAccept={(value: string) => {
          if (onChange) {
            onChange({
              target: { value }
            } as React.ChangeEvent<HTMLInputElement>);
          }
        }}
        {...props}
        onFocus={(e) => {
          setShowMask(true);
          props.onFocus?.(e);
        }}
        onBlur={(e) => {
          if (value === mask) {
            onChange?.({
              target: { value: '' }
            } as React.ChangeEvent<HTMLInputElement>);
          }
          props.onBlur?.(e);
          setShowMask(false);
        }}
      />
    );
  }
);

MaskedInput.displayName = 'MaskedInput';

export default MaskedInput;
